import * as THREE from 'three';

// hooks
import { useThree } from '@react-three/fiber';

// media
import eyeImg from '../../../media/eyeTexture.jpg';
import decentralandSatImg from '../../../media/decentralandSatMap.png';

// shaders
// import WorldMeshMaterialFragmentGLSL from './WorldMeshMaterialFragment.glsl';
// import WorldMeshMaterialVertexGLSL from './WorldMeshMaterialVertex.glsl';
const WorldMeshMaterialFragmentGLSL = `
uniform sampler2D tex;

varying vec3 vNormal;

void main() {
	vec2 uv = normalize( vNormal ).xy * 0.5 + 0.5;

	vec3 color = texture2D( tex, uv ).rgb;

	// if ( vNormal.z < - 0.85 ) color = vec3( 0.777, 0.74, 0.74 ); // back of eye
	
	gl_FragColor = vec4( color, 1.0 );
}`;
const WorldMeshMaterialVertexGLSL = `
varying vec3 vNormal;

void main() {

	vNormal = normal;

	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

}`;

function WorldMeshMaterial() {
    let eyeTex = new THREE.TextureLoader().load(eyeImg);
    let dclSatMapTex = new THREE.TextureLoader().load(decentralandSatImg);
    // let eyeImg = <img src={eyeImgSrc} alt="" onLoad={() => eyeTex = new THREE.Texture(eyeImg) } />;

    return (
        <shaderMaterial
            uniforms={{
                tex: {
                    value: dclSatMapTex
                }
            }}
            vertexShader={WorldMeshMaterialVertexGLSL}
            fragmentShader={WorldMeshMaterialFragmentGLSL}
         />
    )
}
export default WorldMeshMaterial;